module.exports = __webpack_public_path__ + "static/bannerBackground-3328979e0c36d46f5cfdf555b71131f9.jpg";